import { createContext } from "react";

import { Language } from "@/model/Language/Language";

export const TranslationContext = createContext<Language | null>(null);
export const TranslationProvider = TranslationContext.Provider;
export const TranslationConsumer = TranslationContext.Consumer;
